import React from 'react';

import { Oval } from 'react-loader-spinner';

import type { SimpleCircleSpinnerProperties } from './SimpleCircleSpinner.types';

export const SimpleCircleSpinner: React.FC<SimpleCircleSpinnerProperties> = ({
  dataTest = 'simple_circle_spinner',
  size = '15',
  isLoading,
  mainColor = 'primary',
  secondColor = 'secondary',
  arcWidth,
  trackWidth = 2,
}) => {
  // Oval retains an aria-busy progressbar even for visible=false and defaults
  // visible to true for undefined. An idle spinner must have no busy DOM.
  if (!isLoading) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  // Oval's viewBox side is 40 + max(arc, track), so solving
  // arc * size / (40 + arc) >= 1 gives arc >= 40 / (size - 1).
  // Larger sizes keep the original 2-unit stroke; explicit widths are untouched.
  const numericSize = Number(size);
  const defaultArcWidth = Number.isFinite(numericSize) && numericSize > 1
    ? Math.max(2, 40 / (numericSize - 1))
    : 2;

  return (
    <span data-testid={dataTest} style={{ display: 'contents' }}>
      <Oval
        width={size}
        height={size}
        color={`var(--mui-palette-${mainColor}-main)`}
        secondaryColor={`var(--mui-palette-${secondColor}-main)`}
        // Oval names are reversed: strokeWidth controls the track; the arc
        // inherits strokeWidthSecondary from its group (AF-579 / AF-581).
        strokeWidth={trackWidth}
        strokeWidthSecondary={arcWidth ?? defaultArcWidth}
      />
    </span>
  );
};
